const REFERENCE_MARKER_LABELS = {
  regular_close: "Regular close",
  prior_close: "Prior close",
  official_close: "Official close",
  prior_settlement: "Prior settlement",
  reference_close: "Reference close",
};

const finitePrice = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export const buildMarketReferencePriceLines = ({
  priceMarkers = [],
  livePrice = null,
  palette,
} = {}) => {
  const activePrice = finitePrice(livePrice);
  const seen = new Set();

  return (Array.isArray(priceMarkers) ? priceMarkers : [])
    .map((marker) => {
      const role = String(marker?.role || "").trim().toLowerCase();
      const label = REFERENCE_MARKER_LABELS[role];
      const value = finitePrice(marker?.price);
      if (!label || value == null) return null;
      if (activePrice != null && Math.abs(value - activePrice) < Number.EPSILON) {
        return null;
      }
      const key = `${role}:${value}`;
      if (seen.has(key)) return null;
      seen.add(key);

      return {
        value,
        color: palette?.mutedText || palette?.line || "#64748b",
        lineWidth: 1,
        dashed: true,
        label,
        axisLabelVisible: true,
        marketRole: role,
      };
    })
    .filter(Boolean);
};
